import React from 'react';

// ═══════════════════════════════════════════════════════════════════════
// <TecladoNumerico /> — teclado numérico on-screen padrão do app.
// Extraído do App.js (era const inline) para módulo próprio, de modo que
// tanto o App.js (app logado) quanto o Auth.js (login/recuperação, arquivo
// separado) usem o MESMO componente sem dependência circular.
//
// Cores espelham o objeto G do App.js — tokens de marca fixos.
//
// Props:
//   valor           — string exibida no display
//   label           — rótulo mostrado no header ("Editando: <label>")
//   onDigito(d)     — chamado ao tocar um dígito (ou '.')
//   onApagar()      — chamado no ←
//   onLimpar()      — chamado em Limpar
//   onFechar()      — chamado no ✓ OK
//   permitirDecimal — false esconde o '.' (campos inteiros / código)
// ═══════════════════════════════════════════════════════════════════════
const G = {
  verde:       '#1B6B2F',
  verdeLight:  '#E8F5EC',
  laranja:     '#F47C3C',
  laranjaLight:'#FFF0E6',
  fundo:       '#FAFAF7',
  card:        '#FFFFFF',
  txt1:        '#1A1A1A',
  txt2:        '#6B7280',
  vermelho:    '#DC2626',
  vermelhoL:   '#FEF2F2',
};

// `visor` chega pronto de quem chama: em dinheiro, o que se quer ver
// enquanto digita e "30.000.000,00", nao "30000000" (design system 7.8.1).
// O teclado nao formata nada por conta propria — ele nao sabe de que campo
// veio o numero.
const TecladoNumerico = ({ valor, visor, label, onDigito, onApagar, onLimpar,
                          onFechar, permitirDecimal = true }) => {
  // A tecla é a VÍRGULA, não o ponto (design system 2.3, item 7.8.2): no
  // Brasil é ela que separa os centavos, e era ela que o dedo procurava. Quem
  // recebe o `onDigito` é que decide o que fazer com o sinal — aqui dentro, o
  // <CampoNumericoBP60M /> o converte para ponto antes de guardar.
  const digitos = ['7','8','9','4','5','6','1','2','3',
                   permitirDecimal ? ',' : '', '0','←'];
  return (
    <div style={{ background: G.card, borderRadius: 0,
      padding: 16, border: `2px solid ${G.verde}` }}>
      {label && (
        <div style={{ fontSize: 12, color: G.txt2, marginBottom: 10,
          fontWeight: 700, textTransform: 'uppercase' }}>
          Editando: {label}
        </div>
      )}
      <div style={{ fontSize: 24, fontWeight: 800, color: G.verde,
        marginBottom: 12, padding: '8px 12px',
        background: G.verdeLight, borderRadius: 0, textAlign: 'right',
        minHeight: 24, fontFamily: 'monospace, monospace' }}>
        {visor ?? valor ?? ' '}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {digitos.map((d, i) => d === '' ? (
          <div key={i}/>
        ) : (
          <button key={i} type="button"
            onClick={() => d === '←' ? onApagar() : onDigito(d)}
            style={{ padding: '14px', fontSize: 18, fontWeight: 700,
              borderRadius: 0, border: 'none', cursor: 'pointer',
              background: d === '←' ? G.laranjaLight : G.fundo,
              color: d === '←' ? G.laranja : G.txt1 }}>
            {d}
          </button>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr',
        gap: 8, marginTop: 8 }}>
        <button type="button" onClick={onLimpar}
          style={{ padding: '12px', fontSize: 13, fontWeight: 700,
            borderRadius: 0, border: 'none', cursor: 'pointer',
            background: G.vermelhoL, color: G.vermelho }}>
          Limpar
        </button>
        <button type="button" onClick={onFechar}
          style={{ padding: '12px', fontSize: 13, fontWeight: 700,
            borderRadius: 0, border: 'none', cursor: 'pointer',
            background: G.verdeLight, color: G.verde }}>
          ✓ OK
        </button>
      </div>
    </div>
  );
};

export default TecladoNumerico;
